module.exports = __webpack_public_path__ + "img/margin-trading-icon.8ca27da2.png";